export function log(type, filename, message, value, value2, value3, value4, isDebugMode){
    if(isDebugMode === false || isDebugMode === "false"){
        return;
    }

    if(sessionStorage.getItem("filename") == undefined || sessionStorage.getItem("filename") == null || sessionStorage.getItem("filename") !== filename){
        console.groupEnd();
        sessionStorage.setItem("filename", filename);
        console.group(filename);
    }

    if(filename === undefined){
        filename = "";
    }
    if(message === undefined){
        message = "";
    }

    if(value === undefined){
        value = "";
    }else{
        try {
            value = JSON.parse(JSON.stringify(value));
            // eslint-disable-next-line no-empty
        }catch (ex){}
    }

    if(value2 === undefined){
        value2 = "";
    }else{
        try {
            value2 = JSON.parse(JSON.stringify(value2));
            // eslint-disable-next-line no-empty
        }catch (ex){}
    }

    if(value3 === undefined){
        value3 = "";
    }else{
        try {
            value3 = JSON.parse(JSON.stringify(value3));
            // eslint-disable-next-line no-empty
        }catch (ex){}
    }

    if(value4 === undefined){
        value4 = "";
    }else{
        try {
            value4 = JSON.parse(JSON.stringify(value4));
            // eslint-disable-next-line no-empty
        }catch (ex){}
    }

    var allowOnlyFile = undefined;
    if(filename === allowOnlyFile || allowOnlyFile === undefined){
        if(type === "DBG"){
            console.debug(message, value, value2, value3, value4);
        }else if(type === "WARN"){
            console.group("Warning");
            console.warn(message);
            console.debug(value, value2, value3, value4);
            console.groupEnd();
        }else if(type === "ERR"){
            console.group("Error");
            console.error(message);
            console.debug(value, value2, value3, value4);
            console.groupEnd();
        }
    }
}